import { ActionIcon, Group, Image, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import SearchIcon from "@/assets/search.svg";

interface SearchInputProps {
  search: string;
  placeholder?: string;
  onClearSearch: () => void;
  onSearchInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput = ({
  search,
  placeholder,
  onClearSearch,
  onSearchInputChange,
}: SearchInputProps) => {
  return (
    <Group justify="space-between" w={"100%"}>
      <TextInput
        placeholder={placeholder}
        leftSection={<Image src={SearchIcon} width={18} height={18} />}
        value={search}
        rightSection={
          search && (
            <ActionIcon radius={"50%"} onClick={onClearSearch} size={"sm"}>
              <IconX size={16} />
            </ActionIcon>
          )
        }
        w={"100%"}
        radius="md"
        className="search-input"
        onChange={onSearchInputChange}
      />
    </Group>
  );
};

export default SearchInput;
